import { render, staticRenderFns } from "./Antecedent.vue?vue&type=template&id=9b01b764&scoped=true"
import script from "./Antecedent.vue?vue&type=script&lang=js"
export * from "./Antecedent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b01b764",
  null
  
)

export default component.exports